<template>
    <div class="home-payment-section" v-if="indexPage != null && paymentPage != null">
        <div class="container">
            <div class="section-title">
                <h2>{{ indexPage.payment_title }}</h2>
            </div>
            <div class="column-container-parent">
                <div class="column-left">
                    <hypothecCalculator></hypothecCalculator>
                </div>
                <div class="column-right">
                    <h3 v-html="indexPage.payment_blue_title"></h3>
                    <div class="column-list">
                        <ul>
                            <li v-for="item in indexPage.payment_links">
                                <router-link :to="item.link_item.path">{{ item.link_item.name }}</router-link>
                            </li>
                        </ul>
                    </div>
                    <button class="btn-more" @click="openContactsFormModal('call-page-get', 'home-page', 'Другие варианты покупки')">
                        {{indexPage.payment_btn_consult}}
                        <svgIcon name="arrow-right" class="icon-right-arrow"/>
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import {mapGetters} from 'vuex'
    import svgIcon from '@/components/partials/SvgIcon.vue'
    import hypothecCalculator from '@/components/payment-page/hypothec-calculator.vue'
    export default {
        name: 'home-payment-section',
        components: {
            svgIcon,
            hypothecCalculator,
        },
        data () {
            return {
                dataArr: null,
                globalLang: window.GlobalLang, 
            }
        },
        computed: mapGetters({
            indexPage: 'loadIndexPage',
            paymentPage: 'loadPaymentPage',
            isMobileChecker: 'loadIsMobileChecker',
        }),
        methods: {
            openContactsFormModal(param, page, block) {
                this.$store.commit('formGlobalParam_set', param);
                this.$store.commit('formGlobalDataModal_set', {'page' : page, 'block' : block});
                this.$store.commit('formModalContainerOpen');
            },
        },
        beforeCreate() {
        },
        created () {
        },
        mounted() {
        }
    }
</script>

<style lang="scss">
    @import '@/styles/components/home-page/home-payment.scss';
    @import '@/styles/components/home-page/respond/home-payment-respond.scss';
    // @import '@/styles/components/home-page/respond/home-sales-respond.scss';
    // @import '@/styles/components/home-page/respond/home-actions-respond.scss';
    // @import '@/styles/components/home-page/respond/home-promo-respond.scss';
</style>